import { phoneNumber } from '@/components/CourseDescriptionPageProfessional/CourseCurriculum/constants';

const faqHeading = 'Frequently Asked Questions';

const faqsData = [
  {
    _id: '1',
    question: 'What is PW Skills and What type of Courses does it provide?',
    answer:
      'PW Skills is a platform and a medium to provide upskilling that is affordable and accessible to all. With the mission to provide high-quality, industry-relevant courses, PW Skills aims to empower professionals and students alike to either jumpstart their careers or leverage existing skills with new, future-driven upgrades that will help them realize their full potential. We provide services to upskill in various domains of interest like Web development, Data Science, Digital Marketing, Product management, and many more. You may contact us at +917349432553 to learn about more options.',
  },
  {
    _id: '2',
    question: 'Who are these courses suitable for?',
    answer:
      'Our programs are designed to suit the needs of all candidates (unless specifically mentioned) regardless of their background; be it tech or non-tech. All our programs start from the very basics to build a strong foundation and go all the way to the advanced level. If you are looking to upskill, look no further.',
  },
  {
    _id: '3',
    question: 'Will these courses make me job worthy?',
    answer:
      'At PW Skills, all our programs cover core concepts that are currently used in industry practices. Thus, once the candidate completes the course successfully with sincere efforts, they, for sure, will be employable. Additionally, we have specific Job Assistance programs that the candidate can take up. This ensures that the deserving candidates get relevant interviewing opportunities post successful completion of the course.',
  },
  {
    _id: '4',
    question: 'Are internships provided?',
    answer: `Upon successful completion of the course, you will be provided with internship/job opportunities based on your caliber, qualifications, and final score in our employability test. 
As a part of the preparation, during the course, you will be provided with multiple projects (along with soft skill training) for a holistic understanding of industry-relevant practices to solve real-world problems and flawless presentation. This will be provided in addition to the regular course content and assignments.
      `,
  },
  {
    _id: '5',
    question: 'What if my PC/Laptop is not suitable for these courses?',
    answer: `In most cases, you will not be required to purchase a new PC/Laptop. It's the CPU and RAM capacity that might be lacking. In that case, you can either go for an upgrade or temporarily resort to an online IDE, as suggested by the mentor/SME.`,
  },
  {
    _id: '6',
    question: 'How will my doubts be solved or cleared?',
    answer:
      'Please check your program details to verify if doubt-solving sessions are provided or not. For the programs where doubt support is mentioned, you can clear your doubts by joining the doubt-clearing sessions held during specific days as per your course. Our SMEs would be happy to help you.',
  },
  {
    _id: '7',
    question: 'How long does it take for the support team to revert to the tickets/issues?',
    answer:
      'We strive to attend to your queries within 24 business hours. Someone from the support team will reach out to you within 7-8 hours. Just make sure that you pick up their call or attend to the mail from the support team seeking clarity for resolving your problem.',
  },
  {
    _id: '8',
    question: 'Will the classes be live or recorded?',
    answer: `Please check the batch details to see if it is in Live or Hybrid format. In case of Live class courses, a recording of the class will start to appear on the dashboard within 24 hours of the commencement of the class. 
For Hybrid classes, there would be a good mix of pre-recorded lectures (for self-paced learning) and live revision sessions.`,
  },
  // {
  //   _id: '8',
  //   question: 'How often the recorded videos are provided?',
  //   answer:
  //     'Recorded content is uploaded within 24 hours of the live session. Also, we provide previous batch recordings in advance in case the candidate wants to self-pace the course.',
  // },
  {
    _id: '9',
    question: 'How do I contact the Sales Team?',
    answer: `You can reach out to the sales team via ${phoneNumber}.`,
  },

  {
    _id: '10',
    question: 'How to contact the support team?',
    answer: `You can reach out to the support team via
1. Our dedicated email ID support@pwskills.com or,
2. Raising a ticket
Your concern will be addressed and attended to within 24 business hours.`,
  },
  {
    _id: '11',
    question: 'Do the courses start from the basics?',
    answer:
      'Yes, every course starts from the very basics until it is specifically mentioned otherwise. It is then slowly and steadily built from foundational to advanced levels. We are very inclusive for naive learners too.',
  },
  {
    _id: '12',
    question: 'What if I miss attending the live class?',
    answer:
      'All the sessions will be recorded and uploaded on the dashboard within 24 working hours of the completion of the  live class. However, it is advised that you try to be as regular as possible unless you have a valid reason for absence.',
  },
  {
    _id: '13',
    question: 'How long will it take to get my dashboard?',
    answer:
      'You should get your dashboard instantly after enrolling. However, in case you face problems in accessing the dashboard facilities, please reach out to the support team on support@pwskills.com',
  },
  // {
  //   _id: '14',
  //   question: 'Can we get job assurance or job assistance outside India?',
  //   answer:
  //     'Currently, job assurance is only provided for India. However, Job assistance includes Resume Support, Mock interviews and job referrals.The first 2 are provided globally however job referrals if possible will be given outside India (subject to availability).',
  // },
  {
    _id: '14',
    question: `What if I don't submit the assignment on time?`,
    answer:
      'In that case, your assignment will not be evaluated. However, in rare cases(eg. Health issues, family emergencies etc.) the request will be attended to. Kindly check with the team in case of any sudden/perceived lapse in the timeline from your side.',
  },
  {
    _id: '15',
    question: 'Will I get any study material with the course?',
    answer:
      'Attachments (Resources, in the form of lesson plans, ppts, code files) will be provided wherever required.',
  },
  {
    _id: '16',
    question: 'Is it possible to switch from non tech domain to tech domain?',
    answer:
      'Absolutely ! Infact we have many such success stories here at PW Skills. The only thing required is skills. Tech world, now a days, is very dynamic and inclusive. Hence, it does not restrict any background candidate to be a part of it, as long as the candidate is skilled enough to work in the specific technology.',
  },
  {
    _id: '17',
    question: 'How can I download the lecture?',
    answer:
      'There is no need to download the lectures as you will have dashboard access for a sufficient duration. Additionally, since we track your progress on <a href="https://pwskills.com" target="_blank" rel="noopener noreferrer">pwskills.com</a>, the download option will not be relevant.',
  },
  {
    _id: '18',
    question: ' I do not reside in India. Can I still opt for these courses?',
    answer:
      'If the time zone is something that is of concern then you should not worry as every live session is recorded and provided within 24 hours on the dashboard. Additionally, the support team is always there to help and assist you. So, you can learn at your own pace and get the required help at your convenience.',
  },
  {
    _id: '19',
    question: 'Is virtual lab provided with the course?',
    answer:
      'Currently, we do not provide any virtual lab here as there are plenty available as open resources over the internet. Our expert mentors will guide you more on this as and when needed.',
  },
  {
    _id: '20',
    question: 'How does job assistance work?',
    answer:
      'The programs that come under Job Assistance have certain criteria along with a few terms and conditions that need to be met. Kindly refer to the terms and conditions page for the specific program. What you need to understand holistically is that Job Assistance means we will bring the interview opportunities to you post successful course completion.',
  },
  // {
  //   _id: '22',
  //   question: 'How to refer my friends/known for the course ?',
  //   answer:
  //     'Each of our course has the provision to be shared, kindly check for the given option on the course page.',
  // },
  {
    _id: '21',
    question: 'I have enrolled but did not get the course access, whom should I contact ?',
    answer: 'Please reach out to the support team via support@pwskills.com',
  },
  {
    _id: '22',
    question: 'Is there any affiliate options?',
    answer:
      'Yes, we do have an option for you to become an affiliate and the entire process is automated. To know more please visit <a href="https://affiliate.pwskills.com/" target="_blank" rel="noopener noreferrer">affiliate.pwskills.com</a>',
  },
  {
    _id: '23',
    question: 'Can I access the course on PW App ?',
    answer:
      'No, there is no App for PW Skills currently. All the relevant content and info will be available on PW Skills website (<a href="https://pwskills.com" target="_blank" rel="noopener noreferrer">pwskills.com</a>) only.',
  },
  {
    _id: '24',
    question: 'What is the refund criteria ?',
    answer:
      'We operate on a strict no-refund policy. You will be provided with all help and support from PW Skills during the whole learning journey.',
  },
  {
    _id: '25',
    question: 'I am unable to see my course completion certificate?',
    answer:
      'You can generate the course completion certificate from the course analytics section on your dashboard. It can be viewed directly on the main page of your enrolled course and can be easily downloaded with just a click without any hassle. Please note there are specific requirements in terms of videos, assignments, etc to be fulfilled before generating the certificate. If you are still facing issues with generating the certificate please reach out to the support team via support@pwskills.com',
  },
  {
    _id: '26',
    question:
      'I have completed and uploaded my assignments but it is still not updated, whom to contact ?',
    answer: 'Please reach out to the support team via support@pwskills.com',
  },
  {
    _id: '27',
    question: 'Where can I see your placement record ?',
    answer:
      'Kindly visit our hall of fame for more details  <a href="https://halloffame.pwskills.com/" target="_blank" rel="noopener noreferrer">halloffame.pwskills.com</a>',
  },
  {
    _id: '28',
    question: 'Do you provide offline classes (if yes, where and how to enroll) ?',
    answer: ` Yes, we do have an offline course, kindly reach out to the counseling team to know more about it please connect on ${phoneNumber}.`,
  },
  {
    _id: '29',
    question: 'Are there any degree programs that you provide?',
    answer:
      'Yes, there are plenty of options available at PW Medharthi. To know more about it, please visit <a href="https://pwskills.com/online-degree/?page_ref=home_page" target="_blank" rel="noopener noreferrer">https://pwskills.com/online-degree/?page_ref=home_page</a>',
  },
  {
    _id: '30',
    question: 'I am a working professional, can I benefit from these courses?',
    answer:
      'Yes, these programs are suitable for everyone whether a student or a working professional. Since we provide a good mix of both live and recorded lectures, anyone can avail the benefit of learning at their own pace. Additionally, our support team is fully functional throughout the week 12 hours every day so you can learn uninterrupted.',
  },
  {
    _id: '31',
    question: 'Is it mandatory to take live classes?',
    answer:
      'It depends on the course you have enrolled in. It is, however, recommended that you attend live sessions as much as you can since it can be utilized as a good opportunity to interact with the mentors and have a quick revision of the concepts.',
  },
  {
    _id: '32',
    question: 'Are there any attendance criteria for the courses?',
    answer:
      'This criteria is mostly course-specific. However, as a general practice at PW Skills, we take 60 % attendance as the minimum criteria. This includes watching self-paced recorded content, attending live sessions, and submitting assignments and quizzes within the deadline.',
  },
  {
    _id: '33',
    question: 'I am a working professional, am I allowed to do this course?',
    answer:
      'Absolutely! These courses are not considered moonlighting since they are academically aligned. Leaning and Projects which you are doing as a part of upskilling, as long as you are not generating money or using your organization’s data here, it will surely be a learning journey only.',
  },
  {
    _id: '34',
    question:
      'Is there any restriction wrt the degree if I wish to do any course through PW Skills?',
    answer:
      'There is no such restriction as to which degree you need to possess in order to enroll in the course but as far as the basic requirement for job assistance from PW Skills is concerned, you must at least possess a graduation degree in any field/domain. You may also opt for upskilling as a student and look for freelance work or internship through various platforms and hence can use the skills to generate a side income.',
  },
  // {
  //   _id: '38',
  //   question: 'I am not from India how will I manage the live classes?',
  //   answer:
  //     'The course is also recorded post the live sessions so you can view the session in the recorded format post which in case of any doubts the skype support team will be there to assist you.',
  // },
  // {
  //   _id: '39',
  //   question: 'When will you start providing job referrals?',
  //   answer: 'Once the course is completed the referrals are provided.',
  // },
  // {
  //   _id: '40',
  //   question: 'What is the mode of classes?',
  //   answer: 'Online live sessions via ZOOM. Recordings are also provided post the live sessions.',
  // },
  // {
  //   _id: '41',
  //   question: 'I have paid for the course but the dashboard is not visible!',
  //   answer: 'Please contact support team.',
  //   mail: 'support@pwskills.com',
  // },
  // {
  //   _id: '42',
  //   question: 'Is the internship paid or free?',
  //   answer:
  //     'The internship is an unpaid internship as we are not taking any personal work from you. Rather we are providing an opportunity to you to work on live projects and get exposure.',
  // },
  // {
  //   _id: '43',
  //   question: 'Will I get access to a virtual machine or virtual labs?',
  //   answer:
  //     'No, we don’t provide any such facilities. However, we do provide advice as to how you can set up your virtual machine or lab.',
  // },
  // {
  //   _id: '44',
  //   question: 'Will I get cloud access?',
  //   answer: 'No, we only teach you how you can deploy your model to the cloud.',
  // },
  // {
  //   _id: '45',
  //   question: 'Am I eligible for a job guarantee program?',
  //   answer: 'Please go through the terms and conditions of the course.',
  //   url: 'https://pwskills.com/job-guarantee',
  // },
  // {
  //   _id: '46',
  //   question: 'Are these courses suitable for freshers?',
  //   answer:
  //     'Yes, most of our courses have no pre-requisite until and unless it is specifically mentioned in the course description.',
  // },
];

export default { faqHeading, faqsData };
